<template>
	<Autocomplete
		:icon="icon"
		:item-title="(item: Api.CisType) => `${item.description}`"
		:label="label"
		:name="name"
		display-name="Z.I.S. Art"
		endpoint="cistypes"
		data-test="cistypes-autocomplete"
		v-bind="$attrs"
	>
		<template #item="{ item, props }">
			<v-list-item
				v-bind="props"
				:title="`${item.raw.hp_id} - ${item.raw.description}`"
			>
			</v-list-item>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '@/components/templates/Validation/Autocomplete.vue'

defineProps({
	icon: {
		default: '$cisDefault',
		type: String,
	},
	label: {
		default: 'Z.I.S. Art',
		type: String,
	},
	name: {
		default: 'cisTypes',
		type: String,
	},
	permission: {
		default: false,
		type: Boolean,
	},
})
</script>

<style scoped></style>
